export default
[
  "Ashdod|IL|31.79213|34.64966|Asia/Jerusalem|27",
  "Atlanta|US|33.749|-84.38798|America/New_York|336",
  "Austin|US|30.26715|-97.74306|America/Chicago|165",
  "Baghdad|IQ|33.34058|44.40088|Asia/Baghdad|41",
  "Beer Sheva|IL|31.25181|34.7913|Asia/Jerusalem|285",
  "Berlin|DE|52.52437|13.41053|Europe/Berlin|43",
  "Baltimore|US|39.29038|-76.61219|America/New_York|35",
  "Bogota|CO|4.60971|-74.08175|America/Bogota|2582",
  "Boston|US|42.35843|-71.05977|America/New_York|38",
  "Budapest|HU|47.49801|19.03991|Europe/Budapest|104",
  "Buenos Aires|AR|-34.61315|-58.37723|America/Argentina/Buenos_Aires|31",
  "Buffalo|US|42.88645|-78.87837|America/New_York|191",
  "Chicago|US|41.85003|-87.65005|America/Chicago|180",
  "Cincinnati|US|39.162|-84.45689|America/New_York|267",
  "Cleveland|US|41.4995|-81.69541|America/New_York|204",
  "Dallas|US|32.78306|-96.80667|America/Chicago|139",
  "Denver|US|39.73915|-104.9847|America/Denver|1636",
  "Detroit|US|42.33143|-83.04575|America/Detroit|192",
  "Eilat|IL|29.55805|34.94821|Asia/Jerusalem|63",
  "Gibraltar|GI|36.14474|-5.35257|Europe/Gibraltar|11",
  "Haifa|IL|32.81841|34.9885|Asia/Jerusalem|40",
  "Hawaii|US|21.30694|-157.85833|Pacific/Honolulu|18",
  "Helsinki|FI|60.16952|24.93545|Europe/Helsinki|26",
  "Houston|US|29.76328|-95.36327|America/Chicago|30",
  "Jerusalem|IL|31.76904|35.21633|Asia/Jerusalem|786",
  "Johannesburg|ZA|-26.20227|28.04363|Africa/Johannesburg|1767",
  "Kiev|UA|50.45466|30.5238|Europe/Kiev|187",
  "La Paz|BO|-16.5|-68.15|America/La_Paz|3782",
  "Livingston|US|40.79593|-74.31487|America/New_York|98",
  "Las Vegas|US|36.17497|-115.13722|America/Los_Angeles|613",
  "London|GB|51.50853|-0.12574|Europe/London|25",
  "Los Angeles|US|34.05223|-118.24368|America/Los_Angeles|96",
  "Marseilles|FR|43.29695|5.38107|Europe/Paris|28",
  "Miami|US|25.77427|-80.19366|America/New_York|25",
  "Minneapolis|US|44.97997|-93.26384|America/Chicago|262",
  "Melbourne|AU|-37.814|144.96332|Australia/Melbourne|25",
  "Mexico City|MX|19.42847|-99.12766|America/Mexico_City|2240",
  "Montreal|CA|45.50884|-73.58781|America/Toronto|216",
  "Moscow|RU|55.75222|37.61556|Europe/Moscow|144",
  "New York|US|40.71427|-74.00597|America/New_York|57",
  "Omaha|US|41.25861|-95.93779|America/Chicago|315",
  "Ottawa|CA|45.41117|-75.69812|America/Toronto|71",
  "Panama City|PA|8.9936|-79.51973|America/Panama|17",
  "Paris|FR|48.85341|2.3488|Europe/Paris|42",
  "Pawtucket|US|41.87871|-71.38256|America/New_York|0",
  "Petach Tikvah|IL|32.08707|34.88747|Asia/Jerusalem|54",
  "Philadelphia|US|39.95233|-75.16379|America/New_York|8",
  "Phoenix|US|33.44838|-112.07404|America/Phoenix|366",
  "Pittsburgh|US|40.44062|-79.99589|America/New_York|239",
  "Providence|US|41.82399|-71.41283|America/New_York|0",
  "Portland|US|45.52345|-122.67621|America/Los_Angeles|15",
  "Saint Louis|US|38.62727|-90.19789|America/Chicago|149",
  "Saint Petersburg|RU|59.93863|30.31413|Europe/Moscow|11",
  "San Diego|US|32.71533|-117.15726|America/Los_Angeles|20",
  "San Francisco|US|37.77493|-122.41942|America/Los_Angeles|28",
  "Sao Paulo|BR|-23.5475|-46.63611|America/Sao_Paulo|769",
  "Seattle|US|47.60621|-122.33207|America/Los_Angeles|56",
  "Sydney|AU|-33.86785|151.20732|Australia/Sydney|58",
  "Tel Aviv|IL|32.08088|34.78057|Asia/Jerusalem|15",
  "Tiberias|IL|32.79221|35.53124|Asia/Jerusalem|0",
  "Toronto|CA|43.70011|-79.4163|America/Toronto|175",
  "Vancouver|CA|49.24966|-123.11934|America/Vancouver|70",
  "White Plains|US|41.03399|-73.76291|America/New_York|82",
  "Washington DC|US|38.89511|-77.03637|America/New_York|6",
  "Worcester|US|42.26259|-71.80229|America/New_York|164"
]
